// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"52ee2732","437":"b5b8340a","474":"ce9bbec0","558":"dd274475"}[chunkId] + ".css";
};